import React, { useEffect } from "react";
import { getCurrentUserQuery } from "../logic/user";
import { useQuery } from "@apollo/client";
import config from "../../config";
import Loader from "../bootstrap/loader";

export default function UserCheck(props) {
  const currentUserQuery = useQuery(getCurrentUserQuery);
  useEffect(() => {
    const user = currentUserQuery?.data?.classMethods?.User?.getCurrentUser;
    if (user) {
      window.location = `${config.portal}`;
    }
  }, [currentUserQuery?.data]);
  if (currentUserQuery.loading || currentUserQuery?.data?.classMethods?.User?.getCurrentUser) {
    return (<Loader />);
  }
  return (
    <>
      {props.children}
    </>
  );
}

